export default "__VITE_ASSET__CSuqr4lj__"